import {isArray, isObject} from 'lodash';

const state = {
  contact: null,
  step: 1,
  template: null,
}

const mutations = {
  reset(state) {
    //console.log('reset()');
    state.contact = null;
    state.step = 1;
    state.template = null;
  },
  setContact(state, contact) {
    //console.log('setContact()', contact);
    state.contact = contact;
  },
  setStep(state, step) {
    //console.log('setStep()', step);
    state.step = step;
  },
  setTemplate(state, template) {
    //console.log('setTemplate()', template);
    state.template = template;
  }
}

const getters = {
  cart: state => state,
  contact: state => state.contact,
  step: state => state.step,
  template: state => state.template,
  templatePresentationIDs(state, getters) { // MLD-3776
    if (isObject(getters.template) && isArray(getters.template.presentations)) {
      return getters.template.presentations.map(p => p.id);
    }
    return [];
  }
}

const actions = {
  reset({commit}) {
    commit('reset');
  },
  setContact({commit}, contact) {
    commit('setContact', contact)
  },
  setStep({commit}, step) {
    commit('setStep', step);
  },
  prevStep({commit, getters}) {
    if (getters.step > 1) {
      commit('setStep', getters.step - 1);
    }
  },
  nextStep({commit, getters}) {
    if (getters.step < 3) {
      commit('setStep', getters.step + 1);
    }
  },
  setTemplate({commit}, template) {
    commit('setTemplate', template);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
